import {Component, input, Input, InputSignal, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {RoadOccupationStageForm} from '../../forms/road-occupation-stage.form';
import {NgxMaskDirective} from 'ngx-mask';
import {ValidationErrorsComponent} from '../../../../../../../common/validation-errors/validation-errors.component';
import {DatePickerComponent} from '../../../../../../../common/date-picker/date-picker.component';
import {AlertComponent} from '../../../../../../../common/alert/alert.component';
import {
  ExposedMapControlComponent
} from '../../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import {ParcelsCrudComponent} from '../../../components/parcels/parcels-crud/parcels-crud.component';
import {RoadControlsSetComponent} from '../../../components/road-controls-set/road-controls-set.component';
import {CustomValidator} from '../../../../../../../common/forms/custom.validators';

@Component({
  selector: 'app-stage-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective,
    DatePickerComponent,
    AlertComponent,
    ExposedMapControlComponent,
    ParcelsCrudComponent,
    RoadControlsSetComponent
  ],
  templateUrl: './stage-form.component.html'
})
export class StageFormComponent implements OnInit {

  @Input()
  public label: string = '';

  public form: InputSignal<RoadOccupationStageForm | undefined> = input<RoadOccupationStageForm | undefined>();

  @Input()
  public canRemoveStage = true;

  public serviceId: InputSignal<string | null> = input<string | null>(null);
  public applicationId: InputSignal<string | null> = input<string | null>(null);

  public ngOnInit(): void {
    if (this.serviceId() === '07de17ef-cdf2-4317-a77f-d92748a543d9') {
      this.form()?.startDate?.setValidators([Validators.required, CustomValidator.isValidDateFormat()]);
      this.form()?.startDate?.updateValueAndValidity();
    }
  }

}
